module.exports = __webpack_public_path__ + "circle-ca.4d2c0a19.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/circle-ca.png
// module id = 2560
// module chunks = 0